export const LabelsTranslationConstants = {
    patients: {
        master: [
            "admission",
            "patients-fusion"
        ]
    },
    'patients-fusion': [
        "patients/master",
        "admission",
        "patient/medical-record"
    ],
    'appointments-search': [
        "scheduling"
    ],
    procedures: [
        "medicine"
    ],
    diagnostic:[
        "medicine"
    ],
    'patient-census': [
        "admission",
        "patient/vital-signs",
        "patients/gine-triage",
        "patient/medical-record",
    ],
    'visits-consult': [
        "patient/medical-record"
    ],    
    patient: {
        'medical-record': [
            "patient/vital-signs",
            "patients/gine-triage",
            "patient/notes-external",
            "patient/notes/discharge-emergencies",
            "patient/notes/discharge-hospital",
        ],
        confinement: [
            "patient/medical-record"
        ],
    },
    'surgery-search': [
        'schedule-surgery'
    ]
}
